import { render, staticRenderFns } from "./PreviewArea.vue?vue&type=template&id=28569cac&scoped=true"
import script from "./PreviewArea.vue?vue&type=script&lang=js"
export * from "./PreviewArea.vue?vue&type=script&lang=js"
import style0 from "./PreviewArea.vue?vue&type=style&index=0&id=28569cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28569cac",
  null
  
)

export default component.exports